import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { 
  Box, 
  CardContent, 
  Typography
} from '@mui/material';
import { 
  Description as ContractIcon
} from '@mui/icons-material';
import { AuthenticatedTemplate } from "@azure/msal-react";
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { ContractListGrid } from '../components/grids';
import { AddContractDialog } from '../components/dialogs';

const ContractListContent: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company') || '';

  if (!company) {
    return (
      <PageContainer>
        <Box display="flex" justifyContent="center">
          <PageCard sx={{ maxWidth: 800 }}>
            <CardContent sx={{ p: 3, textAlign: 'center' }}>
              <Typography variant="h6" color="error">
                Missing required parameters. Please specify company to view contracts.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, color: '#64748b' }}>
                Company: {company || 'Not specified'}
              </Typography>
            </CardContent>
          </PageCard>
        </Box>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          {/* Professional Header */}
          <Box sx={{ 
            backgroundColor: '#ffffff',
            borderBottom: '2px solid #3b82f6',
            p: 2.5,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <ContractIcon sx={{ fontSize: 32, color: '#3b82f6' }} />
              <Box>
                <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: 600, 
                    color: '#1e293b',
                    mb: 0.5
                  }}
                >
                  Contract Management
                </Typography>
                <Typography 
                  variant="body2" 
                  sx={{ color: '#64748b' }}
                >
                  {company} | All Contracts
                </Typography>
              </Box>
            </Box>
            
            {/* Command Button */}
            <AddContractDialog />
          </Box>
          
          <CardContent sx={{ p: 3, backgroundColor: '#ffffff' }}>
            {/* Contract List Grid */}
            <ContractListGrid />
          </CardContent>
        </PageCard>
      </Box>
    </PageContainer>
  );
};

const ContractList: React.FC = () => {
  return (
    <AuthenticatedTemplate>
      <ContractListContent />
    </AuthenticatedTemplate>
  );
};

export default ContractList;
